import { NAV_ITEMS } from './navigation';
import { ROUTES } from '@/app/router/routes';
import { InboxIcon } from '@/components/icons';

export const QUICK_NAVIGATION = [
  ...NAV_ITEMS,
  { to: ROUTES.messages, label: 'Mes messages', icon: InboxIcon },
].map((item) => ({
  ...item,
  detail: 'Ouvrir la page',
  group: 'Pages',
  keywords:
    item.to === '/cra'
      ? 'activité compte rendu déclarer mois'
      : item.to === '/conges'
        ? 'absence vacances RTT demande solde'
        : item.to === ROUTES.messages
          ? 'messagerie boîte réception non lus'
          : 'affectation client projet',
}));

const normalize = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const searchQuickNavigation = (query: string) => {
  const words = normalize(query).trim().split(/\s+/).filter(Boolean);
  return QUICK_NAVIGATION.filter((item) => {
    const text = normalize(`${item.label} ${item.detail} ${item.keywords}`);
    return words.every((word) => text.includes(word));
  });
};
